import { AUTH_EVENTS, CONTENT_EVENTS, FORM_EVENTS, MARKETING_EVENTS } from '@repo/analytics';

const GA4_EVENT_NAME_MAP: Record<string, string> = {
  [AUTH_EVENTS.login]: 'login',
  [AUTH_EVENTS.signUp]: 'sign_up',
  [CONTENT_EVENTS.searchExecuted]: 'search',
  [FORM_EVENTS.contactSubmitted]: 'generate_lead',
  [MARKETING_EVENTS.campaignAttributed]: 'campaign_details',
};

export function toGa4EventName(eventName: string): string {
  return GA4_EVENT_NAME_MAP[eventName] ?? eventName;
}
